import React from 'react';
import _ from 'lodash';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

const toolbar = [
    // { name: 'document',    items : [ 'Source','-','Save','NewPage','DocProps','Preview','Print','-','Templates' ] },
    { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
    { name: 'editing', items: ['SpellChecker', 'Scayt'] },
    // { name: 'forms',       items : [ 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField' ] },
    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'] },
    {
        name: 'paragraph',
        items: [
            'NumberedList',
            'BulletedList',
            '-',
            'Outdent',
            'Indent',
            '-',
            'Blockquote',
            '-',
            'JustifyLeft',
            'JustifyCenter',
            'JustifyRight',
            'JustifyBlock',
            '-',
            'BidiLtr',
            'BidiRtl',
        ],
    },
    // { name: 'links',       items : [ 'Link','Unlink','Anchor' ] },
    { name: 'insert', items: ['Table'] },
    { name: 'styles', items: ['Format', 'Font', 'FontSize'] },
    { name: 'colors', items: ['TextColor'] },
    // { name: 'tools',       items : [ 'Maximize', 'ShowBlocks','-','About' ] }
];
@observer
export default class SkyCKEditor extends React.Component {
    constructor(props) {
        super(props);
        this.propagateChanges = false;
    }

    componentDidMount() {
        if (!this.props.readOnly) {
            CKEDITOR.on('instanceReady', (evt) => {
                this.updateEditor(this.props);

                if (this.props.handleFormChange) {
                    CKEDITOR.instances[this.props.editorId].on('key', () => {
                        if (this.propagateChanges) {
                            this.props.handleFormChange();
                        }
                    });

                    CKEDITOR.instances[this.props.editorId].on('key', () => {
                        if (this.propagateChanges) {
                            this.props.handleFormChange();
                        }
                    });

                    CKEDITOR.instances[this.props.editorId].on('setData', () => {});
                    CKEDITOR.instances[this.props.editorId].on('afterSetData', () => {
                        this.propagateChanges = true;
                    });
                }
                if (this.props.onReady) {
                    this.props.onReady();
                    this.propagateChanges = true;
                }

                evt.removeListener();
            });
            CKEDITOR.replace(this.props.editorId, {
                height: 350,
                removePlugins: this.props.removePlugins,
                allowedContent: true,
                // extraAllowedContent: '*(*);*{*}',
                extraAllowedContent: 'span;ul;li;table;td;style;*[id];*(*);*{*}',
                toolbar: this.props.toolbar || toolbar,
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        const hasPropsChanged = nextProps.uniqueKeyFromProps !== this.props.uniqueKeyFromProps;
        if (hasPropsChanged) {
            this.updateEditor(nextProps);
        }
    }

    componentWillUnmount() {
        if (this.props.readOnly) return;
        CKEDITOR.instances[this.props.editorId].destroy();
    }

    getMarkup() {
        return this.props.data;
    }

    updateEditor(props) {
        if (props.readOnly) return;
        if (props.data === '') return;

        if (CKEDITOR.instances[props.editorId]) {
            CKEDITOR.instances[props.editorId].setData(props.data);
        }
    }

    resetData(data) {
        CKEDITOR.instances[this.props.editorId].setData(data);
    }

    render() {
        return (
            <div id={this.props.container} style={{ marginBottom: 15 }}>
                {!this.props.readOnly ? (
                    <div>
                        <textarea name={this.props.editorId} id={this.props.editorId}></textarea>
                    </div>
                ) : (
                    <div className="panel panel-default">
                        <div
                            dangerouslySetInnerHTML={{ __html: this.getMarkup() }}
                            className="panel-body"
                            style={{ backgroundColor: '#eee' }}
                        ></div>
                    </div>
                )}
            </div>
        );
    }
}

SkyCKEditor.propTypes = {
    container: PropTypes.string.isRequired,
    editorId: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired,
    removePlugins: PropTypes.string,
};

SkyCKEditor.defaultProps = {
    removePlugins: '',
};



// WEBPACK FOOTER //
// ./src/shared/skyckeditor.js